import React from 'react';
import CustomTooltip from '../Tooltips/CustomTooltip';

interface InitialsAvatarProps {
    name: string;
    id?: number;
    size?: number;
    tooltipId?: string;
    unknown?: boolean;
}

const getInitials = (name: string): string => {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// Deterministic ID -> HSL color, so the same person always gets the same color regardless of name changes.
const getColor = (id: number): string => {
    const hue = Math.abs(id * 137) % 360;
    return `hsl(${hue}, 55%, 45%)`;
};

const InitialsAvatar: React.FC<InitialsAvatarProps> = ({ name, id, size = 28, tooltipId = 'initials-avatar-tooltip', unknown = false }) => (
    <CustomTooltip placement="top" message={name} tooltipId={tooltipId}>
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: size,
                height: size,
                borderRadius: '50%',
                backgroundColor: unknown ? '#DC2626' : getColor(id ?? 0),
                color: '#fff',
                fontSize: size * 0.4,
                fontWeight: 600,
                lineHeight: 1,
                userSelect: 'none',
                cursor: 'default',
            }}
        >
            {unknown ? '?' : getInitials(name)}
        </span>
    </CustomTooltip>
);

export default InitialsAvatar;